/** Cálculos alinhados ao HTML legado (calcSc / calcT / nv / lnv). Índice: fi*10 + ti*5 + qi */

export function calcScoresPorForca(flat: number[]): number[] {
  if (flat.length !== 50) throw new Error('respostas: esperado 50 valores');
  const scores: number[] = [];
  for (let fi = 0; fi < 5; fi++) {
    let s = 0;
    for (let ti = 0; ti < 2; ti++) {
      for (let qi = 0; qi < 5; qi++) {
        s += flat[fi * 10 + ti * 5 + qi] ?? 0;
      }
    }
    scores.push(Math.round((s / 50) * 100) / 10);
  }
  return scores;
}

export function calcScoreTema(flat: number[], fi: number, ti: number): number {
  let s = 0;
  for (let qi = 0; qi < 5; qi++) {
    s += flat[fi * 10 + ti * 5 + qi] ?? 0;
  }
  return Math.round((s / 25) * 100) / 10;
}

export function nv(s: number): 'alto' | 'medio' | 'baixo' {
  if (s >= 7) return 'alto';
  if (s >= 4) return 'medio';
  return 'baixo';
}

export function lnv(s: number): string {
  if (s >= 7) return 'Sólida';
  if (s >= 4) return 'Em Desenvolvimento';
  return 'Ponto de Atenção';
}

export function buildScoresJson(flat: number[]): { forcas: number[]; temas: number[] } {
  const forcas = calcScoresPorForca(flat);
  const temas: number[] = [];
  for (let fi = 0; fi < 5; fi++) {
    temas.push(calcScoreTema(flat, fi, 0), calcScoreTema(flat, fi, 1));
  }
  return { forcas, temas };
}

export function mediaGeral(forcas: number[]): number {
  return forcas.reduce((a, b) => a + b, 0) / 5;
}

export function validateRespostasFlat(flat: unknown): flat is number[] {
  if (!Array.isArray(flat) || flat.length !== 50) return false;
  return flat.every((v) => typeof v === 'number' && Number.isInteger(v) && v >= 1 && v <= 5);
}

export function validateRespostasPartial(flat: unknown): flat is (number | null)[] {
  if (!Array.isArray(flat) || flat.length !== 50) return false;
  return flat.every(
    (v) => v === null || (typeof v === 'number' && Number.isInteger(v) && v >= 1 && v <= 5),
  );
}

export function isRespostasComplete(flat: (number | null)[]): flat is number[] {
  return flat.every((v) => v !== null && v >= 1 && v <= 5);
}

export function flatToNumbers(flat: (number | null)[]): number[] {
  return flat.map((v) => v ?? 0);
}
